import React from "react";

function NXShipping({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 5.5H11.5C12.0304 5.5 12.5391 5.71071 12.9142 6.08579C13.2893 6.46086 13.5 6.96957 13.5 7.5V11.5H12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 11.5H0.5V4.5C0.5 4.23478 0.605357 3.98043 0.792893 3.79289C0.98043 3.60536 1.23478 3.5 1.5 3.5H7.5C7.76522 3.5 8.01957 3.60536 8.20711 3.79289C8.39464 3.98043 8.5 4.23478 8.5 4.5V11.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 11.5H5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.25 13.5C9.2835 13.5 8.5 12.7165 8.5 11.75C8.5 10.7835 9.2835 10 10.25 10C11.2165 10 12 10.7835 12 11.75C12 12.7165 11.2165 13.5 10.25 13.5Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 13.5C2.5335 13.5 1.75 12.7165 1.75 11.75C1.75 10.7835 2.5335 10 3.5 10C4.4665 10 5.25 10.7835 5.25 11.75C5.25 12.7165 4.4665 13.5 3.5 13.5Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NXShipping;
